import cloneDeep from 'lodash/cloneDeep';
import unset from 'lodash/unset';
import * as v from 'valibot';

export const partialParse = <
  TSchema extends v.BaseSchema<unknown, unknown, v.BaseIssue<unknown>>,
>(
  schema: TSchema,
  input: unknown,
): Partial<v.InferOutput<TSchema>> => {
  const parsedInput = v.safeParse(schema, input);

  if (parsedInput.success) {
    return parsedInput.output;
  }

  if (parsedInput.issues[0].type === 'array') {
    return [];
  }

  const partialInput = cloneDeep(input) as Partial<v.InferOutput<TSchema>>;
  parsedInput.issues.map((issue) => {
    const dotPath = v.getDotPath(issue);
    if (dotPath) unset(partialInput, dotPath);
  });

  return partialInput;
};
